import template from './feature.template.html'

/* @ngInject */
export default function featureTooltipDirective() {
  return {
    template
  }
}
